export default function configureBlogFilters() {
  const blogFiltersEl = document.querySelector('.js-blog-filters');
  const allBlogFilterCheckboxEls = document.querySelectorAll('.js-blog-filter-checkbox');
  const allItemsChecked = document.querySelectorAll('.js-blog-filter-checkbox--checked');

  function handleBlogFilterClick(e) {
    let url = window.location.href;
    const regex = /(\?page=\d+)/;
    const desiredUrl = url.replace(regex, '');
    url = desiredUrl;
    const { value } = e.target;
    const { name } = e.target;
    const taggedIndex = url.indexOf('/tagged');
    const allItemsWithSameName = document.querySelectorAll(`input[name="${name}"]`);

    let tagToRemove = '';

    allItemsWithSameName.forEach((item) => {
      const { tagToRemove: currentTagToRemove } = item.dataset;
      if (currentTagToRemove) {
        tagToRemove = currentTagToRemove;
      }
    });

    if (taggedIndex > -1) {
      const nextSlashIndex = url.indexOf('/', taggedIndex + 8);
      let taggedValues =
        nextSlashIndex > -1
          ? url.slice(taggedIndex + 8, nextSlashIndex).split('+')
          : url.slice(taggedIndex + 8).split('+');

      // Remove value from tagToRemove if present
      tagToRemove && (taggedValues = taggedValues.filter((val) => val !== tagToRemove));

      if (taggedValues.includes(value)) {
        // Case 2: 'tagged' exists in the URL, and the target value is already present
        const updatedValues = taggedValues.filter((val) => val !== value);
        const newURL = `${url.slice(0, taggedIndex + 8)}${updatedValues.join('+')}${
          nextSlashIndex > -1 ? url.slice(nextSlashIndex) : ''
        }`;

        if (updatedValues.length === 0) {
          // If the last value is removed, redirect to '/blogs/recipes'
          window.location.href = '/blogs/recipes';
        } else {
          window.location.href = newURL;
        }
      } else {
        // Case 1: 'tagged' exists in the URL, but the target value is not present
        const updatedValues = [...taggedValues, value];
        const newURL = `${url.slice(0, taggedIndex + 8)}${updatedValues.join('+')}${
          nextSlashIndex > -1 ? url.slice(nextSlashIndex) : ''
        }`;

        window.location.href = newURL;
      }
    } else {
      // Case 3: 'tagged' does not exist in the URL
      window.location.href = `${url}/tagged/${value}`;
    }
  }

  function handleCheckedItemClick(e) {
    // Remove the tag from the URL and refresh
    let url = window.location.href;
    const regex = /(\?page=\d+)/;
    const desiredUrl = url.replace(regex, '');
    url = desiredUrl;
    const { tagToRemove } = e.target.dataset;
    const taggedIndex = url.indexOf('/tagged');
    const nextSlashIndex = url.indexOf('/', taggedIndex + 8);
    const taggedValues =
      nextSlashIndex > -1
        ? url.slice(taggedIndex + 8, nextSlashIndex).split('+')
        : url.slice(taggedIndex + 8).split('+');

    const updatedValues = taggedValues.filter((val) => val !== tagToRemove);

    const newURL = `${url.slice(0, taggedIndex + 8)}${updatedValues.join('+')}${
      nextSlashIndex > -1 ? url.slice(nextSlashIndex) : ''
    }`;

    window.location.href = newURL;
  }

  if (allItemsChecked) {
    allItemsChecked.forEach((item) => {
      item.addEventListener('click', handleCheckedItemClick);
    });
  }

  if (blogFiltersEl) {
    allBlogFilterCheckboxEls.forEach((blogFilter) => {
      blogFilter.addEventListener('click', handleBlogFilterClick);
    });
  }
}
